export default __webpack_public_path__ + "static/media/x.0da2f140.svg";